import { type Component } from "dreamland/core";

const Bookmarks: Component<{}, {}> = function (cx) {
	return (
		<div class="page">
			<h1>Bookmarks</h1>
		</div>
	);
};

export default Bookmarks;